'use client'

import { useRouter } from 'nextjs-toploader/app'
import { Dropdown, SearchField } from 'shared/antd'
import { SearchDropdown } from 'shared/common/Header/components/SearchDropdown/Universal'
import { Icon } from 'shared/iconpack'
import { TokenStorage } from 'shared/libs/storage'

import { useCallback, useEffect, useState } from 'react'

import { useSetSearchQueryMutation } from 'modules/Search/model/api'

import { useAppSearchParams } from 'shared/hooks/useAppSearchParams'

import { ROUTER_PATHS } from 'shared/config/routerPath/RouterPath'
import { globalStyles } from 'shared/config/styles/globalStyles'

import styles from './HeaderSearch.module.scss'

export function HeaderSearch() {
  const access = TokenStorage.getFromStorage()
  const router = useRouter()
  const { getParam } = useAppSearchParams()
  const searchParam = getParam('search')

  const [searchQuery, setSearchQuery] = useState(searchParam || '')
  const [open, setOpen] = useState(false)
  const [setSearchQueryApi] = useSetSearchQueryMutation()

  const handleSearch = useCallback(async () => {
    if (!searchQuery) return
    try {
      if (access) {
        await setSearchQueryApi({ query: searchQuery }).unwrap()
      }
      setOpen(false)
      router.push(
        ROUTER_PATHS.catalogBySearch.get(encodeURIComponent(searchQuery)),
      )
    } catch (error) {
      // TODO
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router, searchQuery, setSearchQueryApi])

  useEffect(() => {
    setSearchQuery(searchParam || '')
    setOpen(false)
  }, [searchParam])

  return (
    <Dropdown
      placement="bottomLeft"
      trigger={['click']}
      open={open}
      onOpenChange={setOpen}
      destroyPopupOnHide
      dropdownRender={() => <SearchDropdown searchQuery={searchQuery} />}
    >
      <div className={styles.searchWrapper}>
        <SearchField
          prefix={
            <Icon
              name="magnifier"
              size={20}
              color={globalStyles['--icon-secondary']}
            />
          }
          value={searchQuery}
          enterButton={'Найти'}
          onSearch={handleSearch}
          className={styles.search}
          onChange={e => setSearchQuery(e.target.value)}
          placeholder="Ищите товары на маркете"
        />
      </div>
    </Dropdown>
  )
}
